import React from 'react';

const TestSalutation = () => {
  return (
    <div>
      <h2>Ce n'est qu'un test</h2>
    </div>
  );
};

export default TestSalutation;
